import { ReactNode } from 'react'
import { LayoutHeader } from './header/'
import { LayoutFooter } from './footer'
import { LayoutBanner } from './banner'

interface LayoutProps {
  children: ReactNode
  notFound?: '' | 'vacancy-page' | 'company-page'
}

export const Layout = ({ children, notFound = '' }: LayoutProps) => {
  if (notFound) {
    return (
      <div className="flex flex-col min-h-screen items-stretch">
        {notFound === 'vacancy-page' && <LayoutHeader />}
        {children}
        <LayoutFooter />
      </div>
    )
  }

  return (
    <div className="flex flex-col min-h-screen items-stretch">
      <LayoutHeader />
      <main className="flex-1 bg-gray-100 relative s-content">
        <LayoutBanner />
        <div className="relative z-[2] w-full flex flex-col">{children}</div>
      </main>
      <LayoutFooter />
    </div>
  )
}
